import React, { useEffect, useMemo, useState } from "react"
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";


const useAddRunningBooking = () => {
  const [PlayersData, setPlayersData] = useState([]);

  const fetchPlayers = async () => {
    try {
      const response = await apiService.get("/bookings?filter=running");
      setPlayersData(response.data);
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    fetchPlayers();
  }, []);
  // Define the columns for the table
  const columns = React.useMemo(
    () => [
      {
        Header: "PLAYERS",
        accessor: "players",
        headerAlign: "text-center",
        cellAlign: "text-center",
        Cell: ({ value }) => {
          const playerNames = value.split(",").map((name) => name.trim());

          return (
            <div className="group relative">
              <ul className="flex flex-wrap justify-start lg:justify-center items-center ">
                {playerNames.slice(0, 1).map((name, index) => (
                  <li key={index} className="break-words whitespace-normal">
                    {name}
                    {index !== playerNames.length - 1 && " / "}
                  </li>
                ))}
                {playerNames.length > 1 && <span className="font-bold"> ...</span>}
              </ul>

              {/* Full list visible on hover */}
              {playerNames.length > 1 && (
                <div className="w-[250px] absolute bg-white shadow-lg p-2 rounded-md border border-gray-300 z-40 hidden group-hover:block">
                  <span>{playerNames.join(" / ")}</span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "TABLE",
        accessor: "tableType",
      },
      {
        Header: "TIME",
        accessor: "start_time",
        Cell:({value})=>( <div className="text-nowrap">{value}</div>)
      },
      {
        Header: "Play TIME",
        accessor: "play_time",
        headerAlign: "text-left",
        cellAlign: "text-left",
        Cell: ({ row }) => {
          const startTime = row.original.start_time; 
          const startDate = new Date(row.original.start_date); 

          const convertTo24HourFormat = (time) => {
            const [hours, minutesAndPeriod] = time?.split(":");
            const [minutes, period] = minutesAndPeriod?.split(" ");

            let hours24 = parseInt(hours, 10);
            if (period === "PM" && hours24 < 12) hours24 += 12;
            if (period === "AM" && hours24 === 12) hours24 = 0;

            return { hours: hours24, minutes: parseInt(minutes, 10) };
          };

          const { hours, minutes } = convertTo24HourFormat(startTime);

          const startDateTime = new Date(startDate);
          startDateTime.setHours(hours);
          startDateTime.setMinutes(minutes);
          startDateTime.setSeconds(0);
          startDateTime.setMilliseconds(0);

          const [elapsedTime, setElapsedTime] = useState(0);

          useEffect(() => {
            const interval = setInterval(() => {
              const now = Date.now();
              const diffInSeconds = Math.floor((now - startDateTime.getTime()) / 1000);
              setElapsedTime(diffInSeconds);
            }, 1000);

            return () => clearInterval(interval);
          }, [startDateTime.getTime()]);

          const formatDuration = (seconds) => {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            return `${String(hours).padStart(2, "0")}hr:${String(minutes).padStart(2, "0")}min`;
          };

          return (
            <div className="font-semibold">
              {elapsedTime < 0 ? "Starting Soon .." : formatDuration(elapsedTime)}
            </div>
          );
        },
      },
    ],
    []
  );

  // Sample data for the table
  const data = useMemo(() => {
    if (!Array.isArray(PlayersData)) return [];
    return PlayersData?.map((item) => ({
      id: item.id,
      tableType: item.table_type,
      players:
        item.players && item.players.length > 0
          ? item.players.map((player) => player.name).join(", ")
          : "No players",
      start_date: item.start_date.split("T")[0],
      start_time: item.start_time,
    }));
  }, [PlayersData]);

  return { columns, data, fetchPlayers };
};

export default useAddRunningBooking;
